module.exports = __webpack_public_path__ + "static/media/pay-later-deactivate.55fc9817.svg";